module.exports = __webpack_public_path__ + "img/logo-dna.5e6b5231.png";